import React, { useEffect, useState } from "react";
import api from '../../../../../core/services/api'


import { Tooltip } from '@material-ui/core';
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import Grid from '@material-ui/core/Grid'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import Checkbox from '@material-ui/core/Checkbox'

//custom components
import CustomSelect from "../../../components/CustomSelect";


function EditForm(props) {
  const [state, setState] = React.useState({
    error: false,
    disabled: false,
    active: true,
    segment_id: null,
  });

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setState({
      disabled: false,
      error: false,
      segment_id: props.receivers.segments_id
    })
    setName(props.receivers.name);
    setEmail(props.receivers.email);
    setPhone(props.receivers.phone);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  async function handleSubmit() {
    setState((prev) => ({
      ...prev,
      disabled: true
    }))

    try {

        const obj = {
            id: props.receivers.id,
            name: name,
            segments_id: state.segment_id,
            email: email,
            phone: phone 
        }
      await api.put(`receivers`, obj);
      props.getData();

    } catch (error) {
      console.warn(error)
    }

    setOpen(false)

  }



  return (
    <div>
      <Tooltip title="Editar">
        <IconButton onClick={handleClickOpen}>
          <EditIcon style={{ color: "#767676" }} className="icon-small" />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="sm">
      <DialogTitle>Editar Destinatário</DialogTitle>
        <DialogContent>
        <div style={{ marginTop: 12, marginBottom: 12 }}>
            <TextField
              id="name"
              name="name"
              label="Nome"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
            />{" "}
          </div>
          <div style={{ marginTop: 12, marginBottom: 12 }}>
            <TextField
              id="email"
              name="email"
              label="E-mail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
            />{" "}
          </div>
          <div style={{ marginTop: 12, marginBottom: 12 }}>
            <TextField
              id="phone"
              name="phone"
              label="Telefone"
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              fullWidth
            />{" "}
          </div>
          <div style={{ marginTop: 12, marginBottom: 12 }}>
            <CustomSelect
              label="Segmentos"
              value={state.segment_id}
              name="segment_id"
              data={props.segments}
              onChange={(event) => handleChange(event)}
            />
          </div>
        </DialogContent>
        <DialogActions style={{ padding: 12 }}>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button
            disabled={state.disabled}
            onClick={handleSubmit}
            variant="contained"
            style={{ backgroundColor: state.disabled ? "" : "#5ed237", color: state.disabled ? "" : "#fff" }}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default EditForm;
